module.exports = __webpack_public_path__ + "public/img/video_bg.ef5ecf55.jpg";